(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-template"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // FAQ Tab Switching Handler
    function initFAQTabs() {
      const tabButtons = document.querySelectorAll('#faqTabs button[data-bs-toggle="tab"]');
      const conceptsSection = document.querySelector('.about-rove-concepts');
      const labsSection = document.querySelector('.about-rove-lab');

      // Function to show/hide entire sections
      function switchTab(activeTabId) {
        // Hide all sections first
        if (conceptsSection) {
          conceptsSection.style.display = 'none';
        }
        if (labsSection) {
          labsSection.style.display = 'none';
        }

        // Show the active section
        if (activeTabId === '#rove-concepts' && conceptsSection) {
          conceptsSection.style.display = 'block';
        } else if (activeTabId === '#rove-labs' && labsSection) {
          labsSection.style.display = 'block';
        }

        // Update button states
        tabButtons.forEach((btn) => {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });

        const activeButton = document.querySelector(`button[data-bs-target="${activeTabId}"]`);
        if (activeButton) {
          activeButton.classList.add('active');
          activeButton.setAttribute('aria-selected', 'true');
        }
      }

      // Add click handlers to tab buttons
      tabButtons.forEach((button) => {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          const targetTab = this.getAttribute('data-bs-target');
          switchTab(targetTab);
        });
      });

      // Initialize - show concepts section by default
      switchTab('#rove-concepts');
    }

    // Initialize tabs when DOM is ready
    initFAQTabs();

    // Re-initialize if content is dynamically loaded
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if About sections were added
          const hasConceptsSection = document.querySelector('.about-rove-concepts');
          const hasLabsSection = document.querySelector('.about-rove-lab');
          if (hasConceptsSection || hasLabsSection) {
            setTimeout(initFAQTabs, 100); // Small delay to ensure content is fully rendered
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // FAQ Tab Switching Handler
  function initFAQTabs() {
    const tabButtons = document.querySelectorAll('#faqTabs button[data-bs-toggle="tab"]');
    const conceptsSection = document.querySelector('.care-rove-concepts');
    const labsSection = document.querySelector('.care-rove-lab');
    
    // Function to show/hide entire sections
    function switchTab(activeTabId) {
      // Hide all sections first
      if (conceptsSection) {
        conceptsSection.style.display = 'none';
      }
      if (labsSection) {
        labsSection.style.display = 'none';
      }
      
      // Show the active section
      if (activeTabId === '#rove-concepts' && conceptsSection) {
        conceptsSection.style.display = 'block';
      } else if (activeTabId === '#rove-labs' && labsSection) {
        labsSection.style.display = 'block';
      }
      
      // Update button states
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });
      
      const activeButton = document.querySelector(`button[data-bs-target="${activeTabId}"]`);
      if (activeButton) {
        activeButton.classList.add('active');
        activeButton.setAttribute('aria-selected', 'true');
      }
    }
    
    // Add click handlers to tab buttons
    tabButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const targetTab = this.getAttribute('data-bs-target');
        switchTab(targetTab);
      });
    });
    
    // Initialize - show concepts section by default
    switchTab('#rove-concepts');
  }
  
  // Initialize tabs when DOM is ready
  initFAQTabs();
  
  // Re-initialize if content is dynamically loaded
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if FAQ sections were added
        const hasConceptsSection = document.querySelector('.faq-rove-concepts');
        const hasLabsSection = document.querySelector('.faq-rove-lab');
        if (hasConceptsSection || hasLabsSection) {
          setTimeout(initFAQTabs, 100); // Small delay to ensure content is fully rendered
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-product-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const compareProductSwitchBtn = document.querySelectorAll('.compare-product-switch-btn');
  compareProductSwitchBtn.forEach(btn => {
    btn.addEventListener('click', function() {
      const productIndex = this.getAttribute('data-product-index');
      showProductCollection(this.getAttribute('data-collection-index'), productIndex);
      // compareProductSwitchBtn.forEach(btn => btn.classList.remove('active'));
      // this.classList.add('active');
    });
  });

  const navItemLinks = document.querySelectorAll('.nav-item:not(.compare-button-item)');
  navItemLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      navItemLinks.forEach((item) => {
        item.querySelector('.nav-link').classList.remove('active');
        item.classList.remove('active');
      });
      const navLink = this.querySelector('.nav-link');
      navLink.classList.add('active');
      this.classList.add('active');
      showProductCollection(navLink.getAttribute('data-collection-index'), '1');
    });
  });
});
function showProductCollection(collectionIndex, productIndex) {
  const productForms = document.querySelectorAll('.compare-product-form');
  productForms.forEach(form => {
    console.log(form.getAttribute('data-collection-index'), collectionIndex);
    if (form.getAttribute('data-collection-index') === collectionIndex && form.getAttribute('data-product-index') === productIndex) {
      form.classList.remove('hidden');
    } else {
      form.classList.add('hidden');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page-basic-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const countrySelect = document.querySelector('select[name="contact[country_code]"]');
  const flagDisplay = document.getElementById('flagDisplay');
  const codeDisplay = document.getElementById('codeDisplay');
  const phoneInput = document.querySelector('input[name="contact[phone]"]');
  
  if (!countrySelect || !flagDisplay || !codeDisplay || !phoneInput) {
    console.log('Phone field elements not found:', {
      countrySelect: !!countrySelect,
      flagDisplay: !!flagDisplay,
      codeDisplay: !!codeDisplay,
      phoneInput: !!phoneInput
    });
    return;
  }
  
  // Update display when country changes
  function updateCountryDisplay() {
    const selectedOption = countrySelect.options[countrySelect.selectedIndex];
    const flag = selectedOption.getAttribute('data-flag');
    const code = selectedOption.value;
    
    console.log('Updating display:', { flag, code });
    
    if (flag && code) {
      flagDisplay.textContent = flag;
      codeDisplay.textContent = code;
      
      // Update phone input placeholder to show the country code
      phoneInput.placeholder = `Enter phone number`;
    }
  }
  
  // Handle country selection change
  countrySelect.addEventListener('change', function() {
    console.log('Country changed to:', this.value);
    updateCountryDisplay();
    
    // Auto-focus the phone input after selecting a country
    phoneInput.focus();
  });
  
  // Initialize display on page load
  updateCountryDisplay();
  
  // Handle phone input formatting
  phoneInput.addEventListener('input', function(e) {
    let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    
    // Format based on country (basic US formatting for now)
    if (countrySelect.value === '+1' && value.length >= 6) {
      if (value.length === 10) {
        value = value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      } else if (value.length > 6) {
        value = value.replace(/(\d{3})(\d{3})(\d+)/, '($1) $2-$3');
      } else {
        value = value.replace(/(\d{3})(\d{3})/, '($1) $2');
      }
    }
    
    e.target.value = value;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // FAQ Tab Switching Handler
  function initFAQTabs() {
    const tabButtons = document.querySelectorAll('#faqTabs button[data-bs-toggle="tab"]');
    const conceptsSection = document.querySelector('.faq-rove-concepts');
    const labsSection = document.querySelector('.faq-rove-lab');
    
    // Function to show/hide entire sections
    function switchTab(activeTabId) {
      // Hide all sections first
      if (conceptsSection) {
        conceptsSection.style.display = 'none';
      }
      if (labsSection) {
        labsSection.style.display = 'none';
      }
      
      // Show the active section
      if (activeTabId === '#rove-concepts' && conceptsSection) {
        conceptsSection.style.display = 'block';
      } else if (activeTabId === '#rove-labs' && labsSection) {
        labsSection.style.display = 'block';
      }
      
      // Update button states
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });
      
      const activeButton = document.querySelector(`button[data-bs-target="${activeTabId}"]`);
      if (activeButton) {
        activeButton.classList.add('active');
        activeButton.setAttribute('aria-selected', 'true');
      }
    }
    
    // Add click handlers to tab buttons
    tabButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const targetTab = this.getAttribute('data-bs-target');
        switchTab(targetTab);
      });
    });
    
    // Initialize - show concepts section by default
    switchTab('#rove-concepts');
  }
  
  // Initialize tabs when DOM is ready
  initFAQTabs();
  
  // Re-initialize if content is dynamically loaded
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if FAQ sections were added
        const hasConceptsSection = document.querySelector('.faq-rove-concepts');
        const hasLabsSection = document.querySelector('.faq-rove-lab');
        if (hasConceptsSection || hasLabsSection) {
          setTimeout(initFAQTabs, 100); // Small delay to ensure content is fully rendered
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // FAQ Tab Switching Handler
  function initFAQTabs() {
    const tabButtons = document.querySelectorAll('#faqTabs button[data-bs-toggle="tab"]');
    const conceptsSection = document.querySelector('.warranty-rove-concepts');
    const labsSection = document.querySelector('.warranty-rove-lab');
    
    // Function to show/hide entire sections
    function switchTab(activeTabId) {
      // Hide all sections first
      if (conceptsSection) {
        conceptsSection.style.display = 'none';
      }
      if (labsSection) {
        labsSection.style.display = 'none';
      }
      
      // Show the active section
      if (activeTabId === '#rove-concepts' && conceptsSection) {
        conceptsSection.style.display = 'block';
      } else if (activeTabId === '#rove-labs' && labsSection) {
        labsSection.style.display = 'block';
      }
      
      // Update button states
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });
      
      const activeButton = document.querySelector(`button[data-bs-target="${activeTabId}"]`);
      if (activeButton) {
        activeButton.classList.add('active');
        activeButton.setAttribute('aria-selected', 'true');
      }
    }
    
    // Add click handlers to tab buttons
    tabButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const targetTab = this.getAttribute('data-bs-target');
        switchTab(targetTab);
      });
    });
    
    // Initialize - show concepts section by default
    switchTab('#rove-concepts');
  }
  
  // Initialize tabs when DOM is ready
  initFAQTabs();
  
  // Re-initialize if content is dynamically loaded
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if FAQ sections were added
        const hasConceptsSection = document.querySelector('.faq-rove-concepts');
        const hasLabsSection = document.querySelector('.faq-rove-lab');
        if (hasConceptsSection || hasLabsSection) {
          setTimeout(initFAQTabs, 100); // Small delay to ensure content is fully rendered
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

  } catch(e) { console.error(e); }
})();
})();
